export const mutations = {
  SET_PREV_ROUTE: (state, data) => {
    state.prevRoute[data['name']] = data['path'];
  },
};